import React, { useState } from "react";

import "./notioptions.scss";
import Restart from "../restart/restart";
import InlineFeedback from "../inlinefeedback/inlinefeedback";

const NotiOptions = (props:any) => {
  const eventOptions = [
    {
      text: "Too many/Missing notifications",
      id: 1,
    },
     {
      text: "Something else",
      id: 2,
    }
   
  ];

function restart(){
return <div className="noti-restart">
    
    <button 
        className="show-more-link restart-workflow back-arrow-button" 
        onClick={props.actionProvider.handleNotifications}
        title="Go back"
        aria-label="Go back"
        data-tooltip="Go back"
    >
    </button>   

    <button 
        className="show-more-link restart top-arrow-button" 
        onClick={props.actionProvider.handleOptions}
        title="Start from top"
        aria-label="Start from top"
        data-tooltip="Start from top"
    >
    </button>

    <InlineFeedback conversationId={props.conversationId} />
</div>
}

 const [activeIndex, setActiveIndex] = useState(null);
const [isDisabled, setIsDisabled] = useState(false);
const [isClicked, setIsClicked] = useState(false);
const [optionClicked, setOptionClicked] = useState(0);
   const [intitialClassName, setClassName] = useState("option-button");
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const buttonsMarkup = eventOptions.map((option:any,index:any) => (
    <React.Fragment key={option.id}>
      <button 
        onClick={()=>{
          // Prevent multiple clicks after a selection has been made
          if (isDisabled && activeIndex !== index) {
            return;
          }
          setIsLoading(true);
          setIsDisabled(!isDisabled);
          setActiveIndex(index);
          setSelectedOption(option.text);
          setClassName("option-inactive");

          switch(option.id){
            case 1:setOptionClicked(1);props.actionProvider.displaySubscriptions("Notification"); break;
            case 2:
                  setOptionClicked(3);setIsClicked(true);window.open('https://experienceleague.adobe.com/home?support-tab=home#support'); break;
          }
          setIsLoading(false);
        }} 
        className={activeIndex === index?"change-buttons":intitialClassName}  
        aria-pressed={activeIndex === index}
        tabIndex={0} // Ensure all buttons remain in tab order
      >
        {option.text}
      </button>
    </React.Fragment>
  ));

  return (
    <div className="options-container" role="group" aria-label="Notification options">
      {buttonsMarkup}
      {selectedOption && (
        <div aria-live="polite" className="sr-only">
          Selected: {selectedOption}
        </div>
      )}
      {isLoading && (
        <div aria-live="assertive" className="sr-only">
          Icon indicating loading state
        </div>
      )}
      {isClicked?restart():<></>}
      {optionClicked!==3?<Restart startfromtop={props.actionProvider.handleOptions} showfeedback = {props.actionProvider.showFeedback}/>:<></>}
    </div>
  );
};

export default NotiOptions;
